export default __webpack_public_path__ + "media/2.23b42.png";